module.exports = new __parcel__URL__("basic-phrases.52ff8703.jpg").toString();